import { AbstractControl } from "@angular/forms";

export function PasswordNoNumberValidator(control: AbstractControl): any {
  const newPassword = control.value;
  const atLeast1NumberCharacter = /\d/.test(newPassword);

  return !atLeast1NumberCharacter ? { passwordNoNumber: true } : null;
}
